/**
 * Slack integration documentation page
 */

import {DocsContent} from '../../../components/docs/DocsContent';
import {DocsActionButtons} from '../../../components/docs/DocsActionButtons';

export function SlackIntegration() {
  return (
    <DocsContent
      title="Slack Integration"
      description="Share meeting summaries and transcripts directly in Slack."
    >
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Overview</h2>
          <p className="text-textSecondary mb-4">
            The Slack integration allows you to automatically share meeting summaries, action items,
            and transcripts in your Slack channels.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Setup</h2>
          <p className="text-textSecondary mb-4">
            Connect your Slack workspace and configure which channels should receive meeting
            updates.
          </p>
        </section>

        <DocsActionButtons pageTitle="Slack Integration" />
      </div>
    </DocsContent>
  );
}

